import React, { RefObject }  from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend
} from "recharts";
import { LoadingWidget } from "../Components/LoadingWidget";
import { DataHelper } from "../Helpers/DataHelper";
import { ChartDataModel } from "../Models/ChartDataModel";
import { ErrorWindow } from "../Components/ErrorWindow";

export class UploadsPerUser extends React.Component<
    {
        dataClient: DataHelper,
        studyId: string
    },
    {
        userUploadData: ChartDataModel[],
        isBusy: boolean
    }
> {

    // Data structure: 
    // data = [
    //     {
    //         name: "category",
    //         value: number
    //     }
    // ];

    errorWindow:  RefObject<ErrorWindow>;
    constructor(props: any) {
        super(props);
        this.errorWindow = React.createRef();
        this.state = {
            userUploadData: [],
            isBusy: false
        }
    }

    getData = (studyId: string): void => {
        this.setState({ isBusy: true })
        this.props.dataClient.CallDashboardService("GetUploadsPerUser", {}, {studyId: this.props.studyId}, (result: string) => {
            let userUpload = JSON.parse(result);
            this.setState({ userUploadData: userUpload, isBusy: false })
        }, (stautus:number, errorMessage:string)=>{
            (this.errorWindow.current as ErrorWindow).show(stautus, errorMessage)}, "GET", false)}

    componentDidMount(): void {}

    render() {

        return (
            <>
            <ErrorWindow ref={this.errorWindow}/>
            <h3>Cases uploaded per user</h3>
            <div className="chartHolderStreach">
            
                <BarChart
                    width={680}
                    height={300}
                    data={this.state.userUploadData}
                    margin={{
                        top: 0,
                        right: 10,
                        left: 140,
                        bottom: 0
                    }}
                    layout="vertical"
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis type="number"/>
                    <YAxis dataKey="name" type="category" interval={0}/>
                    <Tooltip />
                    <Legend />
                    <Bar name="Unique Cases" dataKey="value2" fill="#9FB6E8" />
                    <Bar name="Upload Sessions" dataKey="value1" fill="#45BCB4" />
                </BarChart>
                <LoadingWidget visible={this.state.isBusy} zIndexLayer={0}></LoadingWidget>
                </div>
            </>
        );
    }
}
